import Axios from "../Axios";

const auth = {
    auth(data: object) {
        return Axios.post('/login', data)
    }
}

export default auth;
